<template>
  <span v-on:mouseover="active = !active" v-on:mouseout="active = !active" class="card-title">
    {{ title }}
    <img class="card-image" v-if="active" :src="imageUrl" :alt="title">
  </span>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
      imageUrl: {
        type: String,
        required: true,
      },
    },
    data() {
      return {
        active: false,
      };
    },
  };
</script>

<style scoped>
  .card-title {
    position: relative;
    overflow: visible;
  }

  .card-image {
    position: absolute;
    left: 0;
    top: 1.5rem;
    width: 250px;
    z-index: 999999;
    white-space: nowrap;
    min-width: 250px;
  }
</style>



// WEBPACK FOOTER //
// CardTitle.vue?0e937601